'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _initialize = require('linksoft/core/initialize');

var _initialize2 = _interopRequireDefault(_initialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function dynamicLoadContent(selectorParam) {
    var selector = selectorParam;
    if (!selector) {
        selector = "a[data-toggle='load'][data-target]";
    }

    (0, _jquery2.default)(selector).click(function (e) {

        e.preventDefault();

        var $t = (0, _jquery2.default)(this);
        var $target = (0, _jquery2.default)($t.data("target"));
        var url = $t.attr("href");

        var payload = $t.data("payload");
        if (payload !== undefined) {
            payload = JSON.parse(decodeURIComponent(payload));
        }

        var idTarget = $t.data("target-id");
        var id = $t.data("id");

        if (idTarget) {
            (0, _jquery2.default)(idTarget).val(id);
        }

        var multiple = $t.data("multiple");

        var modal = $t.data("modal");
        if (modal && multiple !== true) {
            (0, _jquery2.default)(modal).modal("hide");
        }

        if (multiple === true) {
            _jquery2.default.post(url, payload, function (result) {
                $target.append(result);
            });
        } else {
            $target.load(url, payload, function () {
                _initialize2.default.trigger('.modal-content');
            });
        }
    });
};

module.exports = exports.default = function (selectorParam) {
    dynamicLoadContent(selectorParam);

    window.linksoft.dynamicLoadContent = function (selectorParam) {
        dynamicLoadContent(selectorParam);
    };
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/dynamicLoadContent.js
// module id = 252
// module chunks = 0